import _ from 'lodash'
import { Map, isImmutable, List } from 'immutable'

export const DRAWER_MOBILE = ['xs', 'ss']

export const toUnits = (val, units) => {
  if (val === 'auto') {
    return 'auto'
  } else if (val === 'min-content') {
    return 'min-content'
  } else if (val === 'max-content') {
    return 'max-content'
  } else if (units === 'calc') {
    return `calc(${val})`
  } else {
    return `${val}${units}`
  }
}
export const LAYOUT_MODE = ['lg', 'md', 'sml', 'sm', 'xs', 'ss']
export const LAYOUT_DEVICE_MODE = ['md', 'sml', 'sm', 'xs', 'ss']

export const isProjectContainer = (state, uid) => {
  try {
    if (!state || !isImmutable(state)) {
      return false
    }
    if (
      ['DrawerEl', 'Modal', 'Header'].includes(state.getIn(['project', 'Settings', 'elements', uid, 'type'])) ||
      ['Header', 'Footer'].includes(uid)
    ) {
      return true
    }
  } catch (err) {
    console.error(err)
  }

  return false
}

export const getParentIdInModal = (state, parent, isProject) => {
  if (!isProject) {
    return parent
  }
  if (parent == 'Header' || parent == 'Footer') {
    return parent
  }
  let elem = state.getIn(['project', 'Settings', 'elements', parent])
  if (!Map.isMap(elem)) {
    return parent
  }
  if (elem.get('type') == 'DrawerEl' || elem.get('type') == 'Modal') {
    return parent
  }

  if (elem.get('parent')) {
    return getParentIdInModal(state, elem.get('parent'), true)
  }
  return parent
}

export const getRepeatParent = (state, parent, isProject) => {
  if (parent == 'Header' || parent == 'Footer') {
    return null
  }
  let elem
  if (isProject) {
    elem = state.getIn(['project', 'Settings', 'elements', parent])
  } else {
    elem = state.getIn(['pages', state.get('page'), 'Props', 'elements', parent])
  }
  if (!Map.isMap(elem)) {
    return null
  }
  if (elem.get('type') == 'DrawerEl' || elem.get('type') == 'Modal') {
    return null
  }

  if (elem.get('type') === 'RepeatAutoFit') {
    return parent
  }

  if (elem.get('type') === 'Strip') {
    let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
    if (repeatRoot.includes(parent)) {
      return parent
    }
    return null
  }

  if (elem.get('parent')) {
    return getRepeatParent(state, elem.get('parent'), isProject)
  }
  return null
}

export const getFirstParentElement = (elements, elemUID) => {
  const parentUID = elements.getIn([elemUID, 'parent'], null)
  if (parentUID) {
    return getFirstParentElement(elements, parentUID)
  } else {
    return elemUID
  }
}

export const getValueForMode = (styles, mode, preKey, key, defaultVal, xsDefVal) => {
  const lgValue = styles.getIn([...preKey, 'lg', ...key], defaultVal)
  const mdValue = styles.getIn([...preKey, 'md', ...key])
  const smlValue = styles.getIn([...preKey, 'sml', ...key])
  const smValue = styles.getIn([...preKey, 'sm', ...key])
  const xsValue = styles.getIn([...preKey, 'xs', ...key], xsDefVal)
  const ssValue = styles.getIn([...preKey, 'ss', ...key], xsDefVal)
  const values = [lgValue, mdValue, smlValue, smValue, xsValue, ssValue]
  let valueIndex = LAYOUT_MODE.indexOf(mode)
  if (valueIndex !== -1) {
    let value = values[valueIndex]
    do {
      if (typeof value !== 'undefined' && value !== null) {
        return value
      }
      value = values[--valueIndex]
    } while (valueIndex >= 0)
  }
  return lgValue
}

export const getValueForModeJS = (styles, mode, preKey, key, defaultVal, xsDefVal) => {
  const lgValue = _.get(styles, [...preKey, 'lg', ...key], defaultVal)
  const mdValue = _.get(styles, [...preKey, 'md', ...key])
  const smlValue = _.get(styles, [...preKey, 'sml', ...key])
  const smValue = _.get(styles, [...preKey, 'sm', ...key])
  const xsValue = _.get(styles, [...preKey, 'xs', ...key], xsDefVal)
  const ssValue = _.get(styles, [...preKey, 'ss', ...key], xsDefVal)
  const values = [lgValue, mdValue, smlValue, smValue, xsValue, ssValue]

  let valueIndex = LAYOUT_MODE.indexOf(mode)
  if (valueIndex !== -1) {
    let value = values[valueIndex]
    do {
      if (typeof value !== 'undefined' && value !== null) {
        return value
      }
      value = values[--valueIndex]
    } while (valueIndex >= 0)
  }
  return lgValue
}
